/**
 * The one shadow every floating work surface wears: the work menu, the
 * snooze submenu and the hover detail. One value, so a popover beside a
 * menu reads as the same layer of the same product.
 */
export const WORK_SURFACE_SHADOW = '0 10px 30px rgba(15,23,42,0.14)';
